import React from 'react';

import AvailabilityForm from './AvailabilityForm';
import {useCreateProviderAvailabilityMutation} from '../../redux/services/providerAvailabilityApi';

const handleSubmit = ({post}) => async formData => {
  const body = formData;
  const response = await post(body);
  if (response?.error) {
    console.error(new Error(response.error?.data?.errors?.[0]));
    return Promise.reject(response.error?.data?.errors?.[0]);
  }
  return Promise.resolve(response);
};

const NewAvailabilityForm = () => {
  const [post] = useCreateProviderAvailabilityMutation();
  return (
    <AvailabilityForm 
      onSubmit={handleSubmit({post})}
    />
  );
};

export default NewAvailabilityForm;